import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "horizontalAlign", "titleText", "verticalAlign", "width"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AbstractElement from '../elements/AbstractElement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HORIZONTAL_ALIGNMENT_TYPES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};
const VERTICAL_ALIGNMENT_TYPES = {
  top: 'private-multicolumn--align-top',
  middle: 'private-multicolumn--align-middle',
  bottom: 'private-multicolumn--align-bottom'
};
const getTitleText = titleText => {
  return /*#__PURE__*/_jsx(AbstractElement, {
    className: "private-multicolumn__item__title",
    children: titleText
  });
};
export default function UIMultiColumnItem(props) {
  const {
      children,
      className,
      horizontalAlign,
      titleText,
      verticalAlign = 'middle',
      width
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const renderedTitle = titleText ? getTitleText(titleText) : null;
  return /*#__PURE__*/_jsxs("div", Object.assign({}, other, {
    className: classNames("private-multicolumn__item has--vertical-spacing", VERTICAL_ALIGNMENT_TYPES[verticalAlign], className, horizontalAlign && HORIZONTAL_ALIGNMENT_TYPES[horizontalAlign]),
    style: {
      width
    },
    children: [renderedTitle, children]
  }));
}
UIMultiColumnItem.displayName = 'UIMultiColumnItem';
UIMultiColumnItem.propTypes = {
  children: PropTypes.node,
  horizontalAlign: PropTypes.oneOf(Object.keys(HORIZONTAL_ALIGNMENT_TYPES)),
  titleText: PropTypes.node,
  verticalAlign: PropTypes.oneOf(Object.keys(VERTICAL_ALIGNMENT_TYPES)),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIMultiColumnItem.defaultProps = {
  verticalAlign: 'middle'
};